import axios from '../localAxios';
import { getClearRoomURL } from './roomsURLs';

export async function clearRoom({
  roomName,
}: {
  roomName: string;
}): Promise<void> {
  const clearRoomURL = getClearRoomURL();
  await axios.post(clearRoomURL.href, {
    room_name: roomName,
  });
  return;
}
